import { DateTime } from 'luxon';
import { createApiRef } from '@backstage/core-plugin-api';
import {
  CreateAnnouncementRequest,
  CreateCategoryRequest,
  MarkannouncementRead,
  SubscribedGroup,
  SubscriptionRequest,
} from './types';
import {
  Announcement,
  AnnouncementsList,
  AnnouncementStatus,
  Category,
  GroupStats,
} from '@internal/backstage-plugin-announcements-common';

/**
 * @public
 */
export const announcementsApiRef = createApiRef<AnnouncementsApi>({
  id: 'plugin.announcements.service',
});

/**
 * API interface for managing announcements and categories.
 *
 * @public
 */
export interface AnnouncementsApi {
  announcements(opts: {
    max?: number;
    page?: number;
    category?: string;
    active?: boolean;
  }): Promise<AnnouncementsList>;
  announcementByID(id: string): Promise<Announcement>;

  createAnnouncement(request: CreateAnnouncementRequest): Promise<Announcement>;
  updateAnnouncement(
    id: string,
    request: CreateAnnouncementRequest,
  ): Promise<Announcement>;
  deleteAnnouncementByID(id: string): Promise<void>;

  categories(): Promise<Category[]>;
  createCategory(request: CreateCategoryRequest): Promise<void>;
  deleteCategory(slug: string): Promise<void>;

  lastSeenDate(): DateTime;
  markLastSeenDate(date: DateTime): void;
  // getSeenAnnouncements(): string[];
  // markAnnouncementAsSeen(announcementId: string): void;
  // isAnnouncementNew(announcement: Announcement): boolean;

  markAnnouncementRead(options: MarkannouncementRead): Promise<void>;
  getStatus(): Promise<AnnouncementStatus>;
  checkAnnouncementReadStatus(announcementId: string): Promise<boolean>;
  getGroupStats(): Promise<GroupStats[]>;
  subscribeGroups(options: SubscriptionRequest): Promise<void>;
  getSubscribedGroups(): Promise<SubscribedGroup[]>;
  unSubscribeGroups(options: SubscriptionRequest): Promise<void>;
}
